module.exports = Promise.all([parcelRequire.load("3arc9"), parcelRequire.load("dVjEj")]).then(() => parcelRequire('6UX7x'));